   module.exports = {
       redirectUri: window.env.REACT_APP_REDIRECT_URL,
       apiBaseUrl: window.env.REACT_APP_API_URL,
       vapid: window.env.VAPID_PUBLIC_KEY
   };

//module.exports = {
//   redirectUri: 'http://localhost:3000',
//   apiBaseUrl: 'http://localhost:8080/api/v1',
//   vapid: 'BKO5ygfFjJaOsPzE4EX0QCvbfthwMK_vQDiuxewKVINaWodF7hLk4DuJAYhvX3JIbkUXBVjhE61Bh-D4yyYd6L0'
//  };
